import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { TariffsModuleService } from '../proxy/controlling/controllers/tariffs-module.service';

FieldBuilder.setNamespace('Controlling');

export const VARIABLEGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VariableGroup.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.VariableGroup.Code')
    .required()
    .minLength(1)
    .maxLength(25)
    .build(),
  FieldBuilder
    .foreignKey('tariffsModuleId', 'Entity.TariffsModule', TariffsModuleService)
    .displayFromNested('tariffsModule.name')
    .sortBy('tariffsModule.name')
    .build(),
];

export const VARIABLEGROUP_CONFIG = {
  entityName: 'VariableGroup',
  localizationKey: 'Controlling::Entity.VariableGroup',
  fields: VARIABLEGROUP_FIELDS,
  permission: 'ControllingLiquidations.VariableGroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
